module.exports = {
    tag: 'glowing',
    quality: 0.5,
    mana: 2,
    regeneration: 1.0
};